import {ProductAttributeType} from "../tabs/ProductAttributes";
import ProductAttributeNameItem from "./items/ProductAttributeNameItem";
import ProductAttributeImageItem from "./items/ProductAttributeImageItem";

type ProductAttributeImageProps = {
    attr: ProductAttributeType
}

const ProductAttributeImage = ({attr}: ProductAttributeImageProps) => {
    return (
        <div>
            <div>
                <ProductAttributeNameItem attr={attr}/>
                Image
            </div>

            <ProductAttributeImageItem attr={attr}/>
        </div>
    );
};

export default ProductAttributeImage;
